// extracted by mini-css-extract-plugin
export var active = "Mode-module--active--d114b";
export var btn = "Mode-module--btn--7221f";
export var dark = "Mode-module--dark--62067";
export var light = "Mode-module--light--b8f70";
export var toggleWrapper = "Mode-module--toggle-wrapper--a8567";